import asyncCom from '@/CommonDP/commons/asyncCom';

/**
 * @param {*} data
 * @param {*} data.title 弹框名称
 * @param {*} data.formId 流程id
 * @param {*} data.formCode
 * @param {*} data.primaryKeyValue 表单数据回显
 * @param {*} data.dialogWidth 流程弹框宽度
 * @param {*} data.dialogHeight 流程弹框高度
 * @param {*} data.fullscreen 是否全屏
 * @returns
 */
export const vFRDialog = async (data) => {
  const props = { ...data, flowLayoutType: "PC" };
  const { default: components } = await import("./vFormRender_dialog.vue");
  return await asyncCom(components, {}, props);
};

export const vFRH5Dialog = async (data) => {
  const props = { ...data, flowLayoutType: "H5" };
  const { default: components } = await import("./vFormRender_dialog.vue");
  return await asyncCom(components, {}, props);
};
